import cnhLogo from 'assets/cnh_logo.webp';
import cnhLogoBig from 'assets/cnh_logo_big.webp';
import johnDeereLogoBig from 'assets/john_deere_logo_big.webp';
import johnDeereLogo from 'assets/john_deere_logo_small.webp';
import { IntegrationConnectionType, PartnerId } from 'models/Integration';
import trapViewLogo from 'assets/trap_view_logo_small.webp';
import trapViewLogoBig from 'assets/trap_view_logo_big.webp';
import arableLogo from 'assets/arable_logo_small.webp';
import arableLogoBig from 'assets/arable_logo_big.webp';
import sencropLogo from 'assets/sencrop_logo_small.webp';
import sencropLogoBig from 'assets/sencrop_logo_big.webp';
import groguruLogo from 'assets/groguru_logo_small.webp';
import groguruLogoBig from 'assets/groguru_logo_big.webp';
import verisLogoBig from 'assets/veris_logo_big.webp';
import pesslLogo from 'assets/pessl_logo.webp';
import pesslLogoBig from 'assets/pessl_logo_big.webp';
import agFiniti from 'assets/agfiniti-logo.svg';
import valencoLogo from 'assets/valenco_logo.webp';
import farmobileLogo from 'assets/farmobile_logo.webp';
import { WizardStep } from 'models';
import GenericWizardStep from 'views/Integrations/components/GenericWizardStep';
import SelectDateView from 'views/Integrations/components/SelectDateView';
import ImportStep from 'views/Integrations/components/ImportStep';

export const partnerDisplayNames: any = {
  AGINTEGRATED: 'AgIntegrated',
  JOHN_DEERE: 'John Deere',
  CNH: 'CNH',
  MANUAL: 'File Upload',
};

export const integrationsExtraInformation = [
  {
    partner_id: PartnerId.TrapView,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select devices',
        subTitle: 'Select device data from Trap View to import',
        itemDisplayName: 'devices',
        gridColSize: 2,
        importFutureItems: true,
        callFunction: 'get_devices',
        component: GenericWizardStep,
        selectAll: true,
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Trap View',
        component: SelectDateView,
      },
    ],
  },
  {
    partner_id: PartnerId.Arable,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select devices',
        subTitle: 'Select device data from Arable to import',
        component: GenericWizardStep,
        callFunction: 'get_devices',
        itemDisplayName: 'devices',
        gridColSize: 2,
        importFutureItems: true,
        selectAll: true,
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Arable',
        component: SelectDateView,
      },
    ],
  },
  {
    partner_id: PartnerId.Sencrop,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select partners',
        subTitle: 'Select partners from Sencrop to import',
        itemDisplayName: 'partners',
        component: GenericWizardStep,
        type: 'ORGANIZATIONS',
        callFunction: 'get_organizations',
        gridColSize: 1,
        selectAll: false,
      },
      {
        stepOrder: 3,
        name: 'Select devices',
        subTitle: 'Select device data from Sencrop to import',
        itemDisplayName: 'devices',
        component: GenericWizardStep,
        type: 'DEVICES',
        callFunction: 'get_devices',
        importFutureItems: true,
        gridColSize: 2,
        selectAll: true,
      },
      {
        stepOrder: 4,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Sencrop',
        component: SelectDateView,
      },
    ],
  },
  {
    partner_id: PartnerId.GroGuru,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select sites',
        subTitle: 'Select site data from GroGuru to import',
        component: GenericWizardStep,
        callFunction: 'get_sites',
        itemDisplayName: 'sites',
        gridColSize: 2,
        importFutureItems: true,
        selectAll: true,
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from GroGuru',
        component: SelectDateView,
      },
    ],
  },
  {
    partner_id: PartnerId.Veris,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select users',
        subTitle: 'Select a user from Veris to import',
        itemDisplayName: 'users',
        component: GenericWizardStep,
        type: 'USERS',
        callFunction: 'get_users',
        importFutureItems: false,
        gridColSize: 1,
        selectAll: false,
      },
      {
        stepOrder: 3,
        name: 'Select farms',
        subTitle: 'Select farms from Veris to import',
        itemDisplayName: 'farms',
        component: GenericWizardStep,
        type: 'FARMS',
        callFunction: 'get_farms',
        importFutureItems: true,
        gridColSize: 1,
        selectAll: true,
      },
      {
        stepOrder: 4,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Veris',
        component: SelectDateView,
      },
    ],
  },
  {
    partner_id: PartnerId.Pessl,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select stations',
        subTitle: 'Select station data from Pessl to import',
        component: GenericWizardStep,
        callFunction: 'get_stations',
        itemDisplayName: 'stations',
        gridColSize: 2,
        importFutureItems: true,
        selectAll: true,
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Pessl',
        component: SelectDateView,
      },
    ],
  },
  {
    partner_id: PartnerId.AgFiniti,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Import field boundaries',
        subTitle: 'Import your properties and fie',
        component: ImportStep,
        gridColSize: 2,
        importFutureItems: true,
        selectAll: false,
        specialId: 'Import Step',
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from AgFiniti',
        component: SelectDateView,
        jobFrequency: 'DAILY',
      },
      {
        stepOrder: 4,
        name: 'Select growers',
        subTitle: 'Select growers data from AgFiniti to import',
        itemDisplayName: 'growers',
        gridColSize: 2,
        importFutureItems: false,
        callFunction: 'get_growers',
        component: GenericWizardStep,
        selectAll: false,
      },
    ],
  },
  {
    partner_id: PartnerId.Valenco,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select devices',
        subTitle: 'Select device data from Valenco to import',
        component: GenericWizardStep,
        callFunction: 'get_devices',
        itemDisplayName: 'devices',
        gridColSize: 2,
        importFutureItems: true,
        selectAll: true,
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Valenco',
        component: SelectDateView,
      },
    ],
  },
  {
    partner_id: PartnerId.Farmobile,
    showAutofft: false,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select organizations',
        subTitle: 'Select organization data from Farmobile to import',
        component: GenericWizardStep,
        callFunction: 'get_organizations',
        itemDisplayName: 'organizations',
        gridColSize: 2,
        importFutureItems: false,
        selectAll: false,
      },
      {
        stepOrder: 3,
        name: 'Import field boundaries',
        subTitle: '',
        component: ImportStep,
        importFutureItems: true,
        selectAll: false,
        specialId: 'Import Step',
      },
      {
        stepOrder: 4,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Farmobile',
        component: SelectDateView,
        jobFrequency: 'DAILY',
      },
    ],
  },
];

export const integrationOptions = [
  {
    integration_name: 'John Deere Operations Center',
    logo: johnDeereLogo,
    logo_big: johnDeereLogoBig,
    description:
      'The Operations Center is an online farm management system that enables access to farm information anytime, anywhere.',
    description_extended:
      'The Operations Center is an online farm management system that enables access to farm information anytime, anywhere. Tools in the Operations Center provide you and your partners with the ability to analyze, edit, and make collaborative decisions from the same set of information to get higher yields and reduce input costs. These tools help you farm more efficiently by creating plans and directing in-field work, allowing you to farm more acres in less time. Combined with its complimentary suite of mobile apps and the power of live connections to the machine through JDLink™, the Operations Center enables you to manage your operation more efficiently, do a better job on every pass, reduce costs, and improve profitability.Cropwise products integrates user’s data with John Deere Operation Center. On this page press on the “Configure” button. Log into your MyJohnDeere account. In the settings allow the Cropwise application to access your data. You will be automatically redirected to the Integration page.Please note: the first sync, depending on the amount of data in your MyJohnDeere account, takes up to 24 hours. Further, the data will be synchronized much faster — once per hour. Cropwise will regularly request information about field updates, yield maps, etc. from your MyJohnDeere account and upload new data to your Cropwise account.',
    connection_type: IntegrationConnectionType.machinery,
    isPaid: false,
    partner_id: PartnerId.JohnDeere,
    stage: null,
  },
  {
    integration_name: 'CNH Industrial',
    logo: cnhLogo,
    logo_big: cnhLogoBig,
    description: ' Import agronomic data generated by your CNH Industrial agricultural equipment.',
    description_extended: `Cropwise products integrates user’s data with Case IH/New Holland. On this page press on the “Configure” button. Log into your Case IH/New Holland account. In the settings allow the Cropwise application to access your data. You will be automatically redirected to the Integration page.
    \nPlease note: the first sync, depending on the amount of data in your Case IH/New Holland account, takes up to 24 hours. Further, the data will be synchronized much faster — once per hour. Cropwise will regularly request information about field updates, yield maps, etc. from your Case IH/New Holland account and upload new data to your Cropwise account.
    `,
    connection_type: IntegrationConnectionType.machinery,
    isPaid: false,
    partner_id: PartnerId.CNH,
    stage: 'BETA',
    category: 'erp',
  },
  {
    integration_name: 'Trap View',
    logo: trapViewLogo,
    logo_big: trapViewLogoBig,
    description:
      'Trap View provides tools for agronomists. Cropwise integrates user data with Trap View.',
    description_extended:
      'First, tap the "Configure" button in Cropwise. Then, enter Trap View credentials. You will be automatically redirected to the Integrations page when complete.',
    connection_type: IntegrationConnectionType.observation,
    isPaid: false,
    partner_id: PartnerId.TrapView,
    stage: null,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select devices',
        subTitle: 'Select device data from Trap View to import',
        itemDisplayName: 'devices',
        gridColSize: 2,
        importFutureItems: true,
        callFunction: 'get_devices',
        component: GenericWizardStep,
        selectAll: true,
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Trap View',
        component: SelectDateView,
      },
    ],
    category: 'erp',
  },
  {
    integration_name: 'Arable',
    logo: arableLogo,
    logo_big: arableLogoBig,
    description:
      "Arable's ground-truth data, powerful agronomic models, and intuitive design help businesses across the ag and food value chain optimize decisions, improve efficiency, and deliver greater levels of sustainability.",
    description_extended:
      'First, tap the "Configure" button in Cropwise. Then, enter Arable credentials. You will be automatically redirected to the Integrations page when complete.',
    connection_type: IntegrationConnectionType.observation,
    isPaid: false,
    partner_id: PartnerId.Arable,
    stage: null,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select devices',
        subTitle: 'Select device data from Arable to import',
        component: GenericWizardStep,
        callFunction: 'get_devices',
        itemDisplayName: 'devices',
        gridColSize: 2,
        importFutureItems: true,
        selectAll: true,
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Arable',
        component: SelectDateView,
      },
    ],
    category: 'ag_insights',
  },
  {
    integration_name: 'Sencrop',
    logo: sencropLogo,
    logo_big: sencropLogoBig,
    description:
      'Designed to answer the needs of professional farmers, Sencrop offers a range of connected weather stations that bring you precision agricultural weather data straight from your plots.',
    description_extended:
      'First, tap the "Configure" button in Cropwise. Then, enter Sencrop credentials. You will be automatically redirected to the Integrations page when complete.',
    connection_type: IntegrationConnectionType.observation,
    isPaid: true,
    partner_id: PartnerId.Sencrop,
    stage: null,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select partners',
        subTitle: 'Select partners from Sencrop to import',
        itemDisplayName: 'partners',
        component: GenericWizardStep,
        type: 'ORGANIZATIONS',
        callFunction: 'get_organizations',
        gridColSize: 1,
        selectAll: false,
      },
      {
        stepOrder: 3,
        name: 'Select devices',
        subTitle: 'Select device data from Sencrop to import',
        itemDisplayName: 'devices',
        component: GenericWizardStep,
        type: 'DEVICES',
        callFunction: 'get_devices',
        importFutureItems: true,
        gridColSize: 2,
        selectAll: true,
      },
      {
        stepOrder: 4,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Sencrop',
        component: SelectDateView,
      },
    ],
    category: 'weather',
  },
  {
    integration_name: 'GroGuru',
    logo: groguruLogo,
    logo_big: groguruLogoBig,
    description:
      'GroGuru is focused on helping farmers implement strategic water management. We deploy soil sensors that measure things like soil moisture, temperature and salinity.',
    description_extended:
      'First, tap the "Configure" button in Cropwise. Then, enter Groguru credentials. You will be automatically redirected to the Integrations page when complete.',
    connection_type: IntegrationConnectionType.observation,
    isPaid: false,
    partner_id: PartnerId.GroGuru,
    stage: null,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select sites',
        subTitle: 'Select site data from GroGuru to import',
        component: GenericWizardStep,
        callFunction: 'get_sites',
        itemDisplayName: 'sites',
        gridColSize: 2,
        importFutureItems: true,
        selectAll: true,
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from GroGuru',
        component: SelectDateView,
      },
    ],
    category: 'weather',
  },
  {
    integration_name: 'Veris',
    logo: verisLogoBig,
    logo_big: verisLogoBig,
    description:
      'Veris on-the-go soil sensors provide the precise soil maps needed to manage farm fields to their potential.',
    description_extended:
      'Most farmers struggle to apply the right rate of fertilizer, herbicide and other inputs, so Veris created a system for mapping and managing soil across farm fields to improve profitability and soil stewardship. Farmers using this system can feel confident they’re maximizing the potential of their fields and know they are doing the right thing. Cropwise allows you to build high resolution application maps using Veris soil on-the-go soil sensor data.\n\nFirst, tap the "Configure" button in Cropwise. Then, enter Veris credentials. You will be automatically redirected to the Integrations page when complete.',
    connection_type: IntegrationConnectionType.observation,
    isPaid: false,
    partner_id: PartnerId.Veris,
    stage: null,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select users',
        subTitle: 'Select a user from Veris to import',
        itemDisplayName: 'users',
        component: GenericWizardStep,
        type: 'USERS',
        callFunction: 'get_users',
        importFutureItems: false,
        gridColSize: 1,
        selectAll: false,
      },
      {
        stepOrder: 3,
        name: 'Select farms',
        subTitle: 'Select farms from Veris to import',
        itemDisplayName: 'farms',
        component: GenericWizardStep,
        type: 'FARMS',
        callFunction: 'get_farms',
        importFutureItems: true,
        gridColSize: 1,
        selectAll: true,
      },
      {
        stepOrder: 4,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Veris',
        component: SelectDateView,
      },
    ],
    category: 'traps',
  },
  {
    integration_name: 'Pessl Instruments',
    logo: pesslLogo,
    logo_big: pesslLogoBig,
    description: 'Pessl or Pessl-Metos provides services and solutions tailored to your operation.',
    description_extended:
      'Pessl or Pessl-Metos provides services and solutions tailored to your operation, such as weather, soil moisture, pest monitoring, crop disease modeling, and so on.\n\nFirst, tap the "Configure" button in Cropwise. Then, enter Pessl credentials. You will be automatically redirected to the Integrations page when complete.',
    connection_type: IntegrationConnectionType.observation,
    isPaid: false,
    partner_id: PartnerId.Pessl,
    stage: null,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select stations',
        subTitle: 'Select station data from Pessl to import',
        component: GenericWizardStep,
        callFunction: 'get_stations',
        itemDisplayName: 'stations',
        gridColSize: 2,
        importFutureItems: true,
        selectAll: true,
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Pessl',
        component: SelectDateView,
      },
    ],
    category: 'traps',
  },
  {
    integration_name: 'AgFiniti',
    logo: agFiniti,
    logo_big: agFiniti,
    description:
      'AgFiniti connects grower’s entire operation, and allows for sharing of information with trusted advisors.',
    description_extended:
      'Ag Leader Technology offers the highest-quality, year-round precision farming tools that collect valuable information from the field and connect the entire operation across operators, machines and devices. Having access to the right information at the right time, enables operators and machines to work better together, more productively and brings clarity and confidence to the hundreds of decisions made every day. It changes the way of farming. Cropwise products integrates user’s data with Ag Leader AgFiniti.\n\nOn this page press on the “Configure” button. Log into your AgFiniti account. In the settings allow the Cropwise application to access your data. You will be automatically redirected to the Integration page.  \n\nPlease note: the first sync, depending on the amount of data in your AgFiniti account, takes up to 24 hours.  Cropwise will regularly request information about planting maps, yield maps, etc. from your AgFiniti account and upload new data to your Cropwise account. Cropwise is only able to access AgData and ISOXML files available within the My Files area of AgFiniti.',
    connection_type: IntegrationConnectionType.machinery,
    isPaid: false,
    partner_id: PartnerId.AgFiniti,
    stage: null,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Import field boundaries',
        subTitle: 'Import your properties and fie',
        component: ImportStep,
        gridColSize: 2,
        importFutureItems: true,
        selectAll: false,
        specialId: 'Import Step',
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from AgFiniti',
        component: SelectDateView,
        jobFrequency: 'DAILY',
      },
      {
        stepOrder: 4,
        name: 'Select growers',
        subTitle: 'Select growers data from AgFiniti to import',
        itemDisplayName: 'growers',
        gridColSize: 2,
        importFutureItems: false,
        callFunction: 'get_growers',
        component: GenericWizardStep,
        selectAll: false,
      },
    ],
    category: 'traps',
  },
  {
    integration_name: 'Valenco',
    logo: valencoLogo,
    logo_big: valencoLogo,
    description: 'Valenco-based sensors provide access to soil water tension data.',
    description_extended:
      'Valenco is a soil moisture sensing platform based on LoRa communication that uses a granular matrix sensor to measure soil water content or available plant water in Soil Water Tension (0 to 200 CB). It provides soil temperature as well as soil moisture data ( -30 to 50 degree C).\n\nFirst, tap the "Configure" button in Cropwise. Then, enter Valenco credentials. You will be automatically redirected to the Integrations page when complete.',
    connection_type: IntegrationConnectionType.observation,
    isPaid: false,
    partner_id: PartnerId.Valenco,
    stage: 'BETA',
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select devices',
        subTitle: 'Select device data from Valenco to import',
        component: GenericWizardStep,
        callFunction: 'get_devices',
        itemDisplayName: 'devices',
        gridColSize: 2,
        importFutureItems: true,
        selectAll: true,
      },
      {
        stepOrder: 3,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Valenco',
        component: SelectDateView,
      },
    ],
    category: 'machinery',
  },
  {
    integration_name: 'Farmobile DataEngine℠ platform',
    logo: farmobileLogo,
    logo_big: farmobileLogo,
    description:
      'The Farmobile DataEngine℠ platform ingests and automatically standardizes complex, raw sensor data to allow customers to view, share, export and use agronomic and machine data across systems and software.',
    description_extended:
      'The Farmobile DataEngine℠ platform ingests and automatically standardizes complex, raw sensor data to allow customers to view, share, export and use agronomic and machine data across systems and software.\n\nEngineered for scalability and speed, the platform redefines data-as-a-service for the agriculture world. Best-in-class technology, the platform allows for greater data quality, which leads to better insights, easy-to-share-and-compare formats, and the ability to turn farm data into a revenue stream. Built for unparalleled capacity, the platform is built on Amazon Web Service (AWS) IoT and cloud-computing technologies. It includes a back-end technology stack to process data and a front-end mobile and web interface to access and QC data. In essence, it collects and standardizes data attributes on acres, machines and other sources to create a sharable system of record that providing users greater visibility into their operations faster than ever before.',
    connection_type: IntegrationConnectionType.machinery,
    isPaid: false,
    partner_id: PartnerId.Farmobile,
    stage: null,
    showAutofft: false,
    wizardSteps: [
      {
        stepOrder: 2,
        name: 'Select organizations',
        subTitle: 'Select organization data from Farmobile to import',
        component: GenericWizardStep,
        callFunction: 'get_organizations',
        itemDisplayName: 'organizations',
        gridColSize: 2,
        importFutureItems: false,
        selectAll: false,
      },
      {
        stepOrder: 3,
        name: 'Import field boundaries',
        subTitle: '',
        component: ImportStep,
        importFutureItems: true,
        selectAll: false,
        specialId: 'Import Step',
      },
      {
        stepOrder: 4,
        name: 'Set start date',
        subTitle: 'Select the start date to import data from Farmobile',
        component: SelectDateView,
        jobFrequency: 'DAILY',
      },
    ],
    category: 'traps',
  },
];

export const authenticationStep: WizardStep = {
  stepOrder: 0,
  name: 'Enter credentials',
  disabled: true,
  selectAll: false,
};
